import { render, staticRenderFns } from "./TableClean.vue?vue&type=template&id=a2fcb680&scoped=true"
import script from "./TableClean.vue?vue&type=script&lang=js"
export * from "./TableClean.vue?vue&type=script&lang=js"
import style0 from "./TableClean.vue?vue&type=style&index=0&id=a2fcb680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fcb680",
  null
  
)

export default component.exports